<template>
  <div class="result">
    <div class="result_nav">
      <navbar
        :titletext="pageTitle"
        :lefticon="lefticon"
        :lefticonheight="1.8"
        :lefticonwidth="1.8"
        :fontweight="700"
        :fontsize="'1.8rem'"
        @goback="goBack(false)"
      />
    </div>
    <van-row class="box">
      <van-col span="24">
        <img
          class="img"
          src="../../../assets/accountAgent/common/success.png"
          alt=""
        />
        <p class="tips">{{ tips }}</p>
        <div class="btns" v-if="type == 1">
          <btn
            :btntext="'去签署合同'"
            :btnwidth="'100%'"
            :height="'5rem'"
            :bgcolor="'#F9591B'"
            :borderradius="'2.5rem'"
            :btncolor="'#fff'"
            :fontsize="'1.7rem'"
            @btnClick="toSign"
          />
        </div>
        <div class="btns" v-if="type == 2">
          <btn
            :btntext="'查看订单'"
            :btnwidth="'100%'"
            :height="'5rem'"
            :bgcolor="'#F9591B'"
            :borderradius="'2.5rem'"
            :btncolor="'#fff'"
            :fontsize="'1.7rem'"
            @btnClick="toOrder"
          />
          <btn
            :btntext="'返回'"
            :btnwidth="'100%'"
            :height="'5rem'"
            :bgcolor="'#fff'"
            :borderradius="'2.5rem'"
            :btncolor="'#333'"
            :fontsize="'1.7rem'"
            :btnborder="'solid 0.1rem #666'"
            @btnClick="goBack"
          />
        </div>
        <div class="btns" v-if="type == 3">
          <btn
            :btntext="'查看订单'"
            :btnwidth="'100%'"
            :height="'5rem'"
            :bgcolor="'#F9591B'"
            :borderradius="'2.5rem'"
            :btncolor="'#fff'"
            :fontsize="'1.7rem'"
            @btnClick="toOrder"
          />
          <btn
            :btntext="'返回'"
            :btnwidth="'100%'"
            :height="'5rem'"
            :bgcolor="'#fff'"
            :borderradius="'2.5rem'"
            :btncolor="'#333'"
            :fontsize="'1.7rem'"
            :btnborder="'solid 0.1rem #666'"
            @btnClick="goBack"
          />
        </div>
      </van-col>
    </van-row>
  </div>
</template>
<script>
import navbar from "../components/nav-bar.vue";
import btn from "../components/button.vue";
export default {
  components: {
    navbar,
    btn,
  },
  data() {
    return {
      pageTitle: "",
      tips: "",
      type: "", //1支付结果  2签名结果  3申请退还提交结果
      lefticon: require("@/assets/accountAgent/common/back.png"),
    };
  },
  created() {
    this.type = this.$route.query.type;
    if (this.type == 1) {
      this.pageTitle = "支付结果";
      this.tips = "订单支付成功";
    }
    if (this.type == 2) {
      this.pageTitle = "签名结果";
      this.tips = "已成功签名";
    }
    if (this.type == 3) {
      this.pageTitle = "提交结果";
      this.tips = "申请提交成功";
    }
  },
  methods: {
    goBack() {
      this.params("", "", "goBack");
    },

    toSign() {
      this.$router.push({
        path: "/accountAgent/signContract",
        query: {
          from: "h5",
          ordersn: this.$route.query.ordersn,
        },
      });
    },
    toOrder() {
      this.$router.push({
        //支付失败
        path: "/accountAgent/detail",
        query: {
          ordersn: this.$route.query.ordersn,
          from: "result",
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.result {
  height: 100%;
  box-sizing: border-box;
  background: #f5f6f7;

  .result_nav {
    position: fixed;
    top: 0;
    width: 100%;
    padding-top: 4.4rem;
    background-color: #f5f6f7;
    z-index: 3;
  }

  .box {
    padding-top: 10rem;
    box-sizing: border-box;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;

    .van-col {
      background: #fff;
      text-align: center;
      padding: 4.1rem 3.3rem 2.1rem;

      img {
        width: 5.4rem;
        margin-bottom: 2rem;
      }

      .tips {
        height: 2.1rem;
        font-size: 1.5rem;
        color: #333333;
        line-height: 2.1rem;
        margin-bottom: 3.6rem;
      }

      button {
        margin-bottom: 1.5rem;
      }
    }
  }
}
</style>


